import { SEARCH_FILTERS_FOR_URL_SYNC } from 'bundles/search-common/constants/filter';
import { isInFilterTestVariant } from 'bundles/search-common/utils/experimentUtils';

/**
 * Validates whether navigation should be allowed for a given query and URL parameters.
 * Prevents navigation for empty organic searches while allowing navigation when:
 * - Query has content, OR
 * - Query is empty but filters exist AND user is in filter test variant
 *
 * @param queryValue - The search query value to validate
 * @param urlParams - URL parameters/query object to check for filters
 * @returns true if navigation should be allowed, false if it should be prevented
 */
export const shouldAllowSearchNavigation = (queryValue: string, urlParams: Record<string, unknown> = {}): boolean => {
  // Check if this is an empty query for an organic search (without filters)
  const isEmptyQuery = !queryValue.trim();

  // If query has content, always allow navigation
  if (!isEmptyQuery) {
    return true;
  }

  // For empty queries, only allow navigation when filters exist AND will be preserved in URL
  const hasUrlFilters = SEARCH_FILTERS_FOR_URL_SYNC.some((filter) => urlParams?.[filter]);
  const shouldPreserveFilters = isInFilterTestVariant();

  // Only allow empty query navigation when filters exist AND will be preserved in URL
  return hasUrlFilters && shouldPreserveFilters;
};
